const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'lds_client_token';

export const getClientToken = () => localStorage.getItem(TOKEN_KEY);
export const setClientToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearClientToken = () => localStorage.removeItem(TOKEN_KEY);

export class ClientAuthError extends Error {}

const parse = async (res) => {
  const data = await res.json().catch(() => ({}));
  if (res.status === 401) { clearClientToken(); throw new ClientAuthError(data.detail || 'Please sign in'); }
  if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Something went wrong');
  return data;
};

export const portalFetch = (path, options = {}) => fetch(`${BACKEND_URL}${path}`, {
  ...options,
  headers: { 'Content-Type': 'application/json', ...(options.headers || {}), Authorization: `Bearer ${getClientToken() || ''}` }
});

export const portalJson = (path, options) => portalFetch(path, options).then(parse);

export const authPost = async (path, body) => {
  const res = await fetch(`${BACKEND_URL}/api/portal/auth/${path}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Something went wrong');
  if (data.token) setClientToken(data.token);
  return data;
};

export const getMe = async () => {
  if (!getClientToken()) return null;
  try { return await portalJson('/api/portal/auth/me'); } catch { return null; }
};

export const downloadWithAuth = async (path, filename) => {
  const res = await portalFetch(path);
  if (!res.ok) throw new Error('Download failed');
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
};
